export const handleError = (payload: any) => {
  if (payload && "error" in payload && typeof payload.error === "string") {
    return payload.error;
  } else if ("data" in payload) {
    return payload.data.message;
  } else if ("status" in payload && payload.status === 401) {
    return "נא להיכנס לחשבון שלך";
  } else return "משהו השתבש, אנא נסה שוב מאוחר יותר";
};
